module.exports = __webpack_public_path__ + "img/big-Sphere-White-Matte.ee43246c.png";